import React, { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./admin.css";

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");
        if (!token || role !== "admin") {
            navigate("/login");
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("fullName");
        localStorage.removeItem("userId");
        localStorage.removeItem("isAdmin");
        navigate("/");
    };

    // 🔥 ACTIVE LINK STYLE
    const isActive = (path) => {
        if (path === "/admin/dashboard" && location.pathname === "/admin") {
            return "active";
        }
        return location.pathname === path ? "active" : "";
    };

    return (
        <div className="d-flex">

            {/* ================= SIDEBAR ================= */}
            <div
                className="admin-sidebar text-white p-3 d-flex flex-column"
                style={{ minHeight: "100vh", position: "sticky", top: 0 }}
            >

                {/* LOGO */}
                <div className="text-center mb-4">
                    <img
                        src="/img/Logo.png"
                        alt="Logo"
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                            borderRadius: "10px",
                        }}
                    />
                    <h6 className="mt-2">Admin Panel</h6>
                </div>

                {/* NAVIGATION */}
                <Nav className="flex-column">

                    <Nav.Link
                        className={`text-white ${isActive("/admin/dashboard")}`}
                        onClick={() => navigate("/admin/dashboard")}
                    >
                        📊 Dashboard
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/add-news")}`}
                        onClick={() => navigate("/admin/add-news")}
                    >
                        📰 Add News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/manage-news")}`}
                        onClick={() => navigate("/admin/manage-news")}
                    >
                        🛠 Manage News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/epaper")}`}
                        onClick={() => navigate("/admin/epaper")}
                    >
                        📰 ePaper Manager
                    </Nav.Link>

                    {/* USERS (Guest Authors) */}
                    <Nav.Link
                        className={`text-white ${isActive("/admin/user")}`}
                        onClick={() => navigate("/admin/user")}
                    >
                        👤 user
                    </Nav.Link>

                </Nav>

                {/* LOGOUT BUTTON (BOTTOM) */}
                <div className="mt-auto">
                    <Nav.Link
                        className="logout-link"
                        onClick={handleLogout}
                    >
                        🚪 Logout
                    </Nav.Link>
                </div>

            </div>

            {/* ================= MAIN CONTENT ================= */}
            <div className="flex-grow-1 p-4 bg-light">
                <Outlet />
            </div>

        </div>
    );
};

export default AdminLayout;